import { Grid } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { ITotalValue, IVesselKPIColumn } from '../../models/vessel-kpi'
import { VesselKpiTableCell } from '../atoms/VesselKpiTableCell'
interface Props {
  column: IVesselKPIColumn
  craneTotal?: ITotalValue
}
export const CraneTableFooter = observer(({ column, craneTotal }: Props) => (
  <Grid container width={'100%'}>
    {column.hasInbound && <VesselKpiTableCell column={column} value={craneTotal?.inbound ?? 0} />}

    {column.hasOutbound && <VesselKpiTableCell column={column} value={craneTotal?.outbound ?? 0} />}

    {column.hasRestow && <VesselKpiTableCell column={column} value={craneTotal?.restow ?? 0} />}

    <VesselKpiTableCell column={column} value={craneTotal?.total ?? 0} />
  </Grid>
))
